export enum SearchType {
  Country = 1,
  Route = 2,
  Boat = 3,
  MainRoute = 4,
  AnyDestination = 0,
}
